/* global MEDIA_FETCH_COUNT: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import EventSnSearchPage from './EventSnSearchPage';
import QueryHandler from '../components/misc/QueryHandler';

class EventSnSearchPageQueryRenderer extends Component {
  constructor(props) {
    super(props);

    this.snFromUrl = props.match.params.startnumber;
    this.eventIdFromUrl = props.match.params.id;
    this.customerKey = props.match.params.customerKey;
  }

  render() {
    const { match } = this.props;

    return (
      <QueryHandler
        query={graphql`
          query EventSnSearchPageQueryRendererQuery(
            $eventId: ID!
            $startnumber: ID!
            $count: Int!
            $cursor: String
            $language: String
            $secondFactor: String
            $individualPart: String
          ) {
            viewer {
              ...EventSnSearchPage_viewer
            }
          }
        `}
        variables={{
          eventId: this.eventIdFromUrl,
          startnumber: this.snFromUrl,
          count: MEDIA_FETCH_COUNT,
          language: match.params.language,
          secondFactor: this.customerKey,
          individualPart: '',
        }}
        redirectTo={`/event/${this.eventIdFromUrl}`}
        render={props => {
          return (
            <EventSnSearchPage
              viewer={props.viewer}
              snFromUrl={match.params.startnumber}
              customerKey={match.params.customerKey}
            />
          );
        }}
      />
    );
  }
}

EventSnSearchPageQueryRenderer.propTypes = {
  match: PropTypes.object,
};

export default EventSnSearchPageQueryRenderer;
